import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"


const MANUAL_CUSTOMER_LINKS = {
    '4' : '/manuals/druni_manual.pdf',
    '6' : '/manuals/mattel_manual.pdf',
	'28' : '/manuals/ulta_manual.pdf'
}

export default function useManualLink(userData) {
	const manualLink = useSignal(null)
	
	useEffect(() => {
		manualLink.value = MANUAL_CUSTOMER_LINKS[userData?.customerID]
	}, [userData?.customerID])

	return {
		manualLink: manualLink.value,
	}
}